import React, { FC } from 'react';
import { Table } from '../table/Table';
import { TablesNames } from '../../store/tables/tables-context';
import { Title } from '../developers/page-components/Title';
import { mockData } from '../../store/tables/partners/partners-deals-data';
import { useNavigate } from 'react-router-dom';

export const PartnersDealsList: FC = () => {
	const navigate = useNavigate();
	const rowActions = (rowData): JSX.Element => {
		return (
			<div
				className="text-center text-muted fw-bolder fs-7 cursor-pointer"
				onClick={(): void => navigate(`/agencies/deals/partner/${rowData?.original?.id}`)}
			>
				Details
			</div>
		);
	};

	return (
		<div className="mb-10">
			<Table
				name={TablesNames.partnersDealsTableData}
				data={mockData}
				isLoading={false}
				enableRowActions={true}
				rowActions={rowActions}
				actionColumnsSize={50}
				toolbarCustomAction={
					<Title title='Partners' additionalClass='fs-2 ms-2' />
				}
			/>
		</div>
	);
};